<template>
<div class="container-fluid">
	<apps-toolbar title="Installed Addon Apps" icon="fa-th-large"></apps-toolbar>

	<addon-app-card v-for="(app,index) in installedApps" 
		:is-installed="true" 
		:app="app"
		v-on:uninstall="uninstallApp(index,'fetchInstalledApps')"
		v-on:uiLocationChange="appUiLocationChange($event,app)"
		v-on:inTopMenuChange="appInTopMenuChange($event,app)"
		v-on:inSideMenuChange="appInSideMenuChange($event,app)"
		v-on:tokenIsReadonlyChange="appTokenIsReadonlyChange($event,app)">
	</addon-app-card>

	<p v-if="installedApps.length == 0">You don't have any apps installed.</p>

</div>
</template>

<script>
import AppsToolbar from "./AppsToolbar"
import AddonAppCard from "@/components/AddonAppCard"

import AppsMixins from "@/mixins/AppsMixins.js"

export default {

	mixins: [AppsMixins],
	components: {
		AppsToolbar,
		AddonAppCard,
	},
	data() {
		return {
			installedApps: []
		}
	},
	watch: {
		'$store.company'() {
			this.fetchInstalledApps()
		}
	},
	created() {

		this.fetchInstalledApps()
	}
}
</script>

<style type="text/css">
	.app-details-table th,
	.app-details-table td {
		padding: 5px;
		padding-bottom: 2px;
		padding-top: 2px;
	}

	.app-details-table th {
		text-align: right;
		padding-right: 10px;
	}
</style>